export default "__VITE_ASSET__2rWh3hYy__"